import React, { useRef, useState, useEffect, useCallback } from 'react'
import { useDraggable } from 'react-use-draggable-scroll'
import moment from 'moment'
import classNames from 'classnames'
import { InputLabel, MenuItem, Select, Button } from '@material-ui/core'
import styled from 'styled-components'
import { makeStyles } from '@material-ui/core/styles'
import DialogContent from '@mui/material/DialogContent'
import Dialog from '@mui/material/Dialog'
import { toast } from 'react-toastify'

import { API, API_ROUTER } from '../../../../api'

import { DateInput } from '../../../UI'
import BracketModal from './components/modal'

import { transformBracketData } from './utils'
import MobilePlayOff from './components/MobilePlayOff/MobilePlayOff'
import DesktopPlayOff from './components/DesktopPlayOff/DesktopPlayOff'

import s from './styles.module.scss'

const TransModal = styled(Dialog)`
  .MuiPaper-root {
    overflow: visible;
    border-radius: 0;
    background-color: transparent;
  }
`
const useStyles = makeStyles(() => ({
  paper: {
    background: '#707070',
  },
}))

export const PlayOff = ({
  requestData,
  grandFinal,
  tournamentMember,
  isAllowRoundUpdate,
}) => {
  const winnerMatchRef = useRef()
  const loserMatchRef = useRef()
  const dragRef = useRef()
  const { events } = useDraggable(dragRef)
  const classes = useStyles()

  const [data, setData] = useState()
  const [nextMatchId, setNextMatchId] = useState()
  const [nextLoserMatchId, setNextLoserMatchId] = useState()
  const [openBracketModal, setOpenBracketModal] = useState(false)
  const [isLoserMatchActive, setIsLoserMatchActive] = useState(false)
  const [matchItem, setMatchItem] = useState()
  const [openRoundChange, setOpenRoundChange] = useState(false)
  const [inputTime, setInputTime] = useState()
  const [inputDate, setInputDate] = useState()
  const [roundId, setRoudnId] = useState()

  const [roundBestOf, setRoundBestOf] = useState('')
  const [isMobile, setIsMobile] = useState(false)

  // Check if device is mobile using matchMedia for better reliability
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)')

    const checkMobile = () => {
      setIsMobile(mediaQuery.matches)
    }

    checkMobile()
    mediaQuery.addEventListener('change', checkMobile)

    return () => mediaQuery.removeEventListener('change', checkMobile)
  }, [])

  const transformData = useCallback(() => {
    if (requestData?.basket?.length > 1) {
      const maxLengthBasket = requestData?.basket?.reduce(
        (sum, current) =>
          current?.cols?.length > sum ? current?.cols?.length : sum,
        0
      )

      const newArr = requestData?.basket?.splice(
        0,
        requestData?.basket?.length - 1
      )
      const filterArr = newArr?.map(el => {
        if (el?.cols?.length < maxLengthBasket) {
          let newVal = el?.cols
          for (let i = 0; i <= maxLengthBasket - el?.cols?.length; i++) {
            newVal.push({ isFiction: true })
          }

          return {
            ...el,
            cols: newVal,
            type: 'fiction',
          }
        }

        return el
      })

      return setData({
        ...requestData,
        basket: filterArr,
      })
    }

    // Transform and sort bracket data to ensure correct column order
    const transformedData = transformBracketData(requestData)

    return setData(transformedData)
  }, [requestData])

  const handleChangeBestOf = event => {
    setRoundBestOf(event.target.value)
  }

  const setTimeRound = (time, bestOf) => {
    if (time) {
      const correctTime = time?.split(' ')[1].split(':')
      setInputTime(`${correctTime[0]}:${correctTime[1]}`)
      setInputDate(new Date(time?.split(' ')[0]))
    }
    if (bestOf) {
      switch (bestOf) {
        case 'Bo1':
          setRoundBestOf(1)
          break
        case 'Bo3':
          setRoundBestOf(2)
          break
        case 'Bo5':
          setRoundBestOf(3)
          break
        case 'Bo7':
          setRoundBestOf(4)
          break
      }
    }
  }
  const scrollToErrorField = () => {
    setImmediate(() => {
      const targetRef = isLoserMatchActive ? loserMatchRef : winnerMatchRef
      if (targetRef.current) {
        targetRef.current.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'center',
        })
      }
    })
  }

  function setMatchId(nextMatchId, currentMatchId, nextLoserMatchId) {
    setNextMatchId(nextMatchId ? nextMatchId : currentMatchId)
    setNextLoserMatchId(nextLoserMatchId ? nextLoserMatchId : currentMatchId)
  }

  const applyRoundSettings = () => {
    API.request({
      ...API_ROUTER.tournaments.setRoundSettings,
      pathKeys: {
        roundId: roundId,
      },
      data: {
        gameToWin: roundBestOf,
        activeAt:
          moment(inputDate).format('YYYY-MM-DD') + ' ' + inputTime + ':00',
      },
    })
      .then(() => {
        toast.success('Round settings changed successfully')
      })
      .catch(err => {
        console.log(err)
        toast.error(err?.data?.message)
      })
  }

  useEffect(() => {
    transformData()
  }, [transformData])

  return (
    <div
      {...events}
      ref={dragRef}
      className={classNames(
        'play_offContainerBg',
        s.play_offContainer,
        isMobile && s.play_offContainerMobile
      )}
    >
      <TransModal disableEscapeKeyDown open={openRoundChange}>
        <DialogContent className={classNames('modalBg', s.modal)}>
          <div className={s.modalContainer}>
            <InputLabel className={s.roundChangeTitle}>Time</InputLabel>
            <input
              className={s.roundChangeInputTime}
              type='time'
              value={inputTime}
              onChange={e => setInputTime(e.target.value)}
            />
            <InputLabel className={s.roundChangeTitle}>Date</InputLabel>
            <DateInput selected={inputDate} onChange={setInputDate} />
            <InputLabel
              style={{ marginTop: '25px' }}
              className={s.roundChangeTitle}
            >
              Match's format
            </InputLabel>
            <Select
              className={s.roundChangeSelect}
              value={roundBestOf}
              onChange={handleChangeBestOf}
              label="Match's format"
              MenuProps={{
                classes: {
                  paper: classes.paper,
                },
              }}
              inputProps={{
                classes: {
                  root: classes.input,
                },
              }}
            >
              <MenuItem value={1}>BO1</MenuItem>
              <MenuItem value={2}>BO3</MenuItem>
              <MenuItem value={3}>BO5</MenuItem>
              <MenuItem value={4}>BO7</MenuItem>
            </Select>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button
                onClick={() =>
                  isAllowRoundUpdate && setOpenRoundChange(!openRoundChange)
                }
              >
                close
              </Button>
              <Button onClick={() => applyRoundSettings()}>save</Button>
            </div>
          </div>
        </DialogContent>
      </TransModal>
      {!data ||
        (!data?.basket?.length && <div className={s.noData}>No data</div>)}
      {!!(data && data?.basket?.length) && (
        <>
          {isMobile ? (
            <MobilePlayOff
              data={data}
              tournamentMember={tournamentMember}
              setMatchItem={setMatchItem}
              setOpenBracketModal={setOpenBracketModal}
              openBracketModal={openBracketModal}
              isAllowRoundUpdate={isAllowRoundUpdate}
              setOpenRoundChange={setOpenRoundChange}
              openRoundChange={openRoundChange}
              setTimeRound={setTimeRound}
              setRoudnId={setRoudnId}
              nextMatchId={nextMatchId}
              nextLoserMatchId={nextLoserMatchId}
              setMatchId={setMatchId}
              winnerMatchRef={winnerMatchRef}
              loserMatchRef={loserMatchRef}
            />
          ) : (
            <DesktopPlayOff
              data={data}
              grandFinal={grandFinal}
              tournamentMember={tournamentMember}
              isAllowRoundUpdate={isAllowRoundUpdate}
              setOpenRoundChange={setOpenRoundChange}
              openRoundChange={openRoundChange}
              setTimeRound={setTimeRound}
              setRoudnId={setRoudnId}
              setMatchItem={setMatchItem}
              setOpenBracketModal={setOpenBracketModal}
              openBracketModal={openBracketModal}
              nextMatchId={nextMatchId}
              nextLoserMatchId={nextLoserMatchId}
              setMatchId={setMatchId}
              winnerMatchRef={winnerMatchRef}
              loserMatchRef={loserMatchRef}
            />
          )}
        </>
      )}
      <BracketModal
        open={openBracketModal}
        nextLoserMatchId={nextLoserMatchId}
        matchItem={matchItem}
        setNextMatchId={setNextMatchId}
        setNextLoserMatchId={setNextLoserMatchId}
        setOpenBracketModal={setOpenBracketModal}
        scrollToErrorField={scrollToErrorField}
        setIsLoserMatchActive={setIsLoserMatchActive}
      />
    </div>
  )
}

export default PlayOff
